import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('ERROR', {
  STORE_INTERNAL_ERROR: null
});



// WEBPACK FOOTER //
// ./app/constants/ErrorConstants.js